// UserMore.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import CategoryIcon from '../container/CategoryIcon.js';
import withRouter from '../component/WithRouter.jsx';
import { color, headerHeight } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import TextEllipsis from '../style/TextEllipsis.js';
import BackIconResource from '../../img/ic_topbar_back.svg';
import GridDiscoverUsers from '../container/GridDiscoverUsers.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

class UserMore extends Component {
  nextTick = null;

  constructor(props) {
    super(props);
    // fetch data for SSR
    const { staticContext, isFirstPageFetched, category, fetchFeeds } =
      this.props;
    if (staticContext.actions && !isFirstPageFetched) {
      staticContext.actions.push({
        function: fetchFeeds,
        argumentObject: {
          page: 1,
          limit: 20,
          type: category,
          httpProxyHeaders: staticContext.httpProxyHeaders,
        },
      });
    }
  }

  render() {
    const { category, titleI18nId, goBack, t } = this.props;

    return (
      <StyledUserMore>
        <Header>
          <GoBack onClick={goBack}>
            <GoBackIcon src={BackIconResource} title="back" />
          </GoBack>
          <TitleWrapper>
            <CategoryIcon category={category} size={20} />
            <Title>
              {t(titleI18nId, {
                ns: TranslationNamespace.FEED,
              })}
            </Title>
          </TitleWrapper>
          <EmptyHeaderAction />
        </Header>
        <GridDiscoverUsersWrapper>
          <GridDiscoverUsers category={category} withHalo />
        </GridDiscoverUsersWrapper>
      </StyledUserMore>
    );
  }
}

UserMore.propTypes = {
  staticContext: PropTypes.object,
  category: PropTypes.string,
  titleI18nId: PropTypes.string,
  isFirstPageFetched: PropTypes.bool,
  fetchFeeds: PropTypes.func,
  goBack: PropTypes.func,
  t: PropTypes.func.isRequired,
};

UserMore.defaultProps = {
  staticContext: {},
  category: null,
  titleI18nId: null,
  descriptionI18nId: '',
  isFirstPageFetched: false,
  fetchFeeds: () => null,
  goBack: () => null,
};

const StyledUserMore = styled.div`
  position: relative;
  padding-top: calc(${headerHeight}px + var(--space-to-pinned-notification));
  padding-bottom: 48px; // set it to 48 based on design team's feedback (2024.02)
`;

const Header = styled.div`
  position: fixed;
  top: var(--space-to-pinned-notification);
  left: 0px;
  z-index: 2;
  border-bottom: 1px solid ${color.neutral['30_alpha_50']};
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${headerHeight}px;
  background-color: ${color.grey['900']};
  font-size: 16px;
  font-weight: 600;
`;

const EmptyHeaderAction = styled.div`
  width: 32px;
  flex: none;
`;

const GoBack = styled.button`
  ${ResetButtonStyle}
  width: 32px;
  flex: none;
  font-size: 0px;
  :hover {
    opacity: 0.7;
  }
`;

const GoBackIcon = styled.img`
  width: 100%;
  height: auto;
`;

const TitleWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  width: 100%;
  flex: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const Title = styled.div`
  ${TextEllipsis};
  margin-left: 4px;
`;

const GridDiscoverUsersWrapper = styled.div`
  padding-top: 28px;
`;

export default withTranslation()(withRouter(UserMore));
